import React, { useState, useEffect } from 'react';
import { Modal, Input, Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const DeleteConfirmationModal = ({ visible, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [confirmationCode, setConfirmationCode] = useState('');
  const [generatedCode, setGeneratedCode] = useState('');

  useEffect(() => {
    if (visible) {
      // Generate a random 5-digit number
      const newCode = Math.floor(10000 + Math.random() * 90000).toString();
      setGeneratedCode(newCode);
      setConfirmationCode('');
    }
  }, [visible]);

  const handleOk = () => {
    if (confirmationCode === generatedCode) {
      onConfirm();
    }
  };

  return (
    <Modal
      title={t('loan.delete.confirmTitle')}
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      okButtonProps={{ 
        danger: true,
        disabled: confirmationCode !== generatedCode 
      }}
      okText={t('common.delete')}
      cancelText={t('common.cancel')}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Text>{t('loan.delete.confirmText')}</Text>
        <Text strong>{t('loan.delete.enterCode')}</Text>
        <Text type="danger" style={{ fontSize: '24px', textAlign: 'center', display: 'block' }}>
          {generatedCode}
        </Text>
        <Input
          placeholder={t('loan.delete.codePlaceholder')}
          value={confirmationCode}
          onChange={(e) => setConfirmationCode(e.target.value)}
          style={{ marginTop: '16px' }}
        />
      </Space>
    </Modal>
  );
};

export default DeleteConfirmationModal;
